export default "__VITE_ASSET__4b73597e__"